import { useState } from 'react';

export default function WhatsAppButton() {
  const [isPulsing, setIsPulsing] = useState(true);

  return (
    <a
      href="https://wa.me/919743475615"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 cursor-pointer"
      onMouseEnter={() => setIsPulsing(false)}
      onMouseLeave={() => setIsPulsing(true)}
    >
      <div className="relative">
        {/* Pulse Animation */}
        {isPulsing && (
          <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-75"></div>
        )}
        
        {/* Button */}
        <div className="relative w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 hover:shadow-2xl transition-all duration-300">
          <i className="ri-whatsapp-line text-white text-3xl"></i>
        </div>
      </div>
    </a>
  );
}